// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","BrandListItem__icon":"vq_a bik_ke","BrandListItem__name":"vq_b bik_vp"};